import { useContext, useState } from "react";
import { Grid } from "react-feather";
import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import CustomizerContext from "../../_helper/Customizer";
import CubaIcon from "../../assets/images/logo/logo.jpg";

const SidebarLogo = () => {
  const { toggleSidebar } = useContext(CustomizerContext);
  const [toggle, setToggle] = useState(false);

  const openCloseSidebar = () => {
    setToggle(!toggle);
    toggleSidebar(toggle);
  };

  return (
    <div className="logo-wrapper flex justify-center">
      <Link to="/">
        <Image
          attrImage={{
            className: "img-fluid d-inline",
            alt: "",
            width: 120,
          }}
        />
      </Link>
      <div className="back-btn" onClick={() => openCloseSidebar()}>
        <i className="fa fa-angle-left"></i>
      </div>
      <div className="toggle-sidebar" onClick={openCloseSidebar}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
    </div>
  );
};

export default SidebarLogo;
